// removed by extract-text-webpack-plugin
module.exports = {"box":"style__box___3E8_D","option":"style__option___3-iEy","control":"style__control___3yCYQ"};


//////////////////
// WEBPACK FOOTER
// ./src/views/layerPanelView/style.less
// module id = 1916
// module chunks = 0